import Helmet from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router-dom';
import {
  getCameraActions,
  getPageStatus,
  PageLayout,
} from 'components/PageLayout';
import { useGeoEvent } from 'features/geoEvents/hooks/useGeoEvent';
import { ReportDetail } from 'features/reports/components/ReportDetail';
import { useReport } from 'features/reports/hooks/useReport';
import { ReportableGeoEvent } from 'features/reports/components/ReportForm';
import { ForcedTheme } from 'components/ForcedTheme';

export const Report = (
  props: RouteComponentProps<{ id: string }>,
): JSX.Element => {
  const {
    match: {
      params: { id },
    },
  } = props;
  const { t } = useTranslation();
  const { report, isReportInError, isReportLoading } = useReport(Number(id));
  const geoEventId = report?.geoEventId;
  const { geoEvent, isGeoEventLoading, isGeoEventFetchError } =
    useGeoEvent<ReportableGeoEvent>({
      id: geoEventId,
      enabled: Boolean(geoEventId),
    });

  const isError = isReportInError || isGeoEventFetchError;
  const status = getPageStatus({
    isError,
    isLoading: !isError && (isReportLoading || isGeoEventLoading || !geoEvent),
  });

  return (
    <ForcedTheme mode="dark">
      <PageLayout
        data-cname="ReportPage"
        status={status}
        headerBarProps={
          status === 'error'
            ? {
                action: 'back',
                iconActions: getCameraActions(t),
              }
            : undefined
        }
      >
        {geoEvent && (
          <>
            <Helmet>
              <title>{t('geoEvent.reports.header')}</title>
            </Helmet>
            <ReportDetail
              displayRelativeDate={geoEvent.isActive}
              report={report!}
            />
          </>
        )}
      </PageLayout>
    </ForcedTheme>
  );
};
